import cn from 'classnames';
import { Badge, Typography, useDevice } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import styles from "./CopyLinkForProposalModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getRecipientBadgeInfo(_ref) {
  let {
    isSignatureRequired,
    hasSigned,
    isPrimary
  } = _ref;
  if (!isSignatureRequired) return null;
  if (hasSigned) return {
    text: 'Signed',
    skin: 'success',
    badgeSkin: 'success'
  };
  // even if primary contact - if signed return signed
  else if (isPrimary) return {
    text: 'Primary contact',
    skin: 'disabled'
  };
  // if primary contact and not signed return primary contact
  else return {
    text: 'Required to sign',
    skin: 'disabled'
  };
}
function RecipientBadge(props) {
  const badgeInfo = getRecipientBadgeInfo(props);
  return badgeInfo && /*#__PURE__*/_jsx(Badge, {
    rounded: true,
    outlined: true,
    testId: props.testId,
    skin: badgeInfo.badgeSkin,
    children: /*#__PURE__*/_jsx(Typography, {
      skin: badgeInfo.skin,
      variant: "paragraph2",
      children: badgeInfo.text
    })
  });
}
export function CopyLinkForProposalModal(props) {
  const {
    className,
    onClick,
    onError,
    onCopy,
    recipients,
    info,
    testId
  } = props;
  const resolvedTestId = testId || 'copy-to-clipboard';
  const {
    isMobileDevice
  } = useDevice();
  const Recipient = _ref2 => {
    let {
      recipient,
      isPrimary = false
    } = _ref2;
    const {
      email,
      isSignatureRequired,
      hasSigned,
      notificationURL
    } = recipient;
    return /*#__PURE__*/_jsxs("div", {
      className: cn(styles.linkRow, {
        [styles.mobile]: isMobileDevice
      }),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.recipientDetails,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.reviewerDetails,
          children: [/*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            variant: 'paragraph1',
            weight: 'normal',
            testId: 'recipient-name',
            children: recipient.fullName()
          }), /*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            variant: 'paragraph2',
            weight: 'light',
            testId: 'recipient-email',
            children: email
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.badge,
          children: /*#__PURE__*/_jsx(RecipientBadge, {
            isSignatureRequired: isSignatureRequired,
            hasSigned: hasSigned,
            isPrimary: isPrimary,
            testId: "recipient-badge-".concat(email)
          })
        })]
      }), /*#__PURE__*/_jsx(CopyToClipboard, {
        size: isMobileDevice ? 'small' : undefined,
        value: notificationURL,
        buttonLabel: 'Copy',
        onClick: onClick,
        onError: onError,
        onCopy: onCopy,
        buttonClassname: styles.button,
        textfieldClassname: styles.link,
        className: styles.linkWrapper
      })]
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.multipleRecipientsRoot, className),
    "data-testid": resolvedTestId,
    children: [/*#__PURE__*/_jsx(Typography, {
      className: styles.title,
      children: "Links are unique per recipient. Make sure that each link is sent to the intended recipient."
    }), info, /*#__PURE__*/_jsxs("div", {
      className: styles.linksContainer,
      children: [/*#__PURE__*/_jsx(Recipient, {
        recipient: recipients.primary,
        isPrimary: true
      }, recipients.primary.email), recipients.additionalRecipients.length > 0 && /*#__PURE__*/_jsx(Typography, {
        className: styles.additionalRecipientsTitle,
        children: "Additional recipients:"
      }), recipients.additionalRecipients.map(recipient => /*#__PURE__*/_jsx(Recipient, {
        recipient: recipient
      }, recipient.email))]
    })]
  });
}